import smoothscroll from 'smoothscroll-polyfill';

document.addEventListener('DOMContentLoaded', () => {
  smoothscroll.polyfill();
})